import React from "react";
import { Checkbox } from "@/components/ui/checkbox";

export const UrgentAck = ({ checked, onChange, testid = "urgent-ack-checkbox" }) => (
  <label className="mt-3 flex cursor-pointer items-start gap-2 rounded-md border border-red-300 bg-red-50 p-3 text-xs text-red-800" data-testid={`${testid}-label`}>
    <Checkbox checked={checked} onCheckedChange={(v) => onChange(!!v)} data-testid={testid} className="mt-0.5 border-red-500 data-[state=checked]:bg-red-600" />
    <span><b>I understand the Urgent rate</b> — a dedicated driver is sent for my job and the Urgent price shown applies.</span>
  </label>
);
